import { Truck } from "lucide-react";

export function PromoBanner() {
  return (
    <div 
      className="free-delivery-banner bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 text-white py-2.5 px-4 text-center relative overflow-hidden"
      role="banner"
      aria-label="Promotional offer"
    >
      <div className="relative flex items-center justify-center gap-2 text-sm sm:text-base font-medium">
        <Truck className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" aria-hidden="true" />
        <span className="leading-tight">
          Free delivery over £50
        </span>
      </div>
    </div>
  );
}
